// extracted by mini-css-extract-plugin
module.exports = {"component":"CharacterSoulBreaks_component__16X5g","unowned":"CharacterSoulBreaks_unowned__1g8Md"};